import RootState from '../../types';

export const selectIsCurrentSweepstake = (state: RootState) =>
  Boolean(state.sweepstake.currentSweepstakeName && state.sweepstake.currentSweepstakeEnd);

// export const selectIsCurrentSweepstake = (state: RootState) => false;
